import { useState } from 'react';

interface Testimonial {
  id: number;
  name: string;
  role: string;
  image: string;
  rating: number;
  text: string;
}

export default function Testimonials() {
  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: 'Sarah Mitchell',
      role: 'Mother of Two',
      image: 'https://public.readdy.ai/ai/img_res/0c190052a0f27f3235444c79b6a8e872.jpg',
      rating: 5,
      text: 'This kit completely changed how I understand my body. Within a week, I could identify my fertile window with confidence. The instructions are clear and easy to follow, even for someone new to cycle tracking.'
    },
    {
      id: 2,
      name: 'Emily Rodriguez',
      role: 'Wellness Coach',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photograph%20of%20a%20radiant%20smiling%20latina%20woman%20in%20her%20late%20twenties%20with%20long%20dark%20wavy%20hair%20wearing%20a%20sage%20green%20top%20against%20a%20soft%20beige%20background%20natural%20daylight%20genuine%20warm%20expression%20wellness%20professional%20demeanor%20high%20quality%20headshot%20photography%20style&width=400&height=400&seq=testimonial-emily-rodriguez-002&orientation=squarish',
      rating: 5,
      text: 'As a wellness coach, I recommend the Cycle Clarity Starter Kit to all my clients. It empowers women to take control of their fertility naturally. The science-backed approach gives me confidence in recommending it.'
    },
    {
      id: 3,
      name: 'Jessica Thompson',
      role: 'First-Time Mom',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photograph%20of%20a%20joyful%20smiling%20blonde%20woman%20in%20her%20early%20thirties%20with%20medium%20length%20hair%20wearing%20a%20soft%20pink%20sweater%20against%20a%20light%20gray%20background%20natural%20lighting%20genuine%20happy%20expression%20new%20mother%20glow%20approachable%20demeanor%20high%20quality%20headshot%20photography%20style&width=400&height=400&seq=testimonial-jessica-thompson-003&orientation=squarish',
      rating: 5,
      text: 'I was struggling to conceive for months until I discovered this kit. The detailed guidance helped me understand my cycle patterns, and I got pregnant within three months! I wish I had found this sooner.'
    },
    {
      id: 4,
      name: 'Amanda Chen',
      role: 'Yoga Instructor',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photograph%20of%20a%20serene%20smiling%20asian%20woman%20in%20her%20late%20twenties%20with%20long%20straight%20black%20hair%20wearing%20a%20white%20yoga%20top%20against%20a%20soft%20lavender%20background%20natural%20lighting%20peaceful%20calm%20expression%20yoga%20instructor%20wellness%20professional%20demeanor%20high%20quality%20headshot%20photography%20style&width=400&height=400&seq=testimonial-amanda-chen-004&orientation=squarish',
      rating: 5,
      text: 'The Cycle Clarity Starter Kit aligns perfectly with my holistic approach to health. It teaches you to listen to your body and recognize its natural rhythms. A must-have for every woman on her wellness journey.'
    },
    {
      id: 5,
      name: 'Rachel Anderson',
      role: 'Nutritionist',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photograph%20of%20a%20confident%20smiling%20woman%20in%20her%20mid%20thirties%20with%20auburn%20red%20hair%20in%20a%20professional%20bob%20cut%20wearing%20a%20coral%20colored%20blouse%20against%20a%20soft%20ivory%20background%20natural%20lighting%20professional%20nutritionist%20demeanor%20approachable%20expert%20expression%20high%20quality%20headshot%20photography%20style&width=400&height=400&seq=testimonial-rachel-anderson-005&orientation=squarish',
      rating: 5,
      text: 'Understanding your cycle is fundamental to overall health. This kit makes it accessible and straightforward. My clients love how it integrates seamlessly into their daily routines without feeling overwhelming.'
    },
    {
      id: 6,
      name: 'Lauren Martinez',
      role: 'Teacher & Mom',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photograph%20of%20a%20warm%20smiling%20woman%20in%20her%20early%20thirties%20with%20curly%20brown%20hair%20wearing%20glasses%20and%20a%20teal%20cardigan%20against%20a%20soft%20peach%20background%20natural%20lighting%20genuine%20friendly%20expression%20busy%20mom%20teacher%20professional%20demeanor%20high%20quality%20headshot%20photography%20style&width=400&height=400&seq=testimonial-lauren-martinez-006&orientation=squarish',
      rating: 5,
      text: 'As a busy teacher and mom, I needed something simple yet effective. This kit delivered exactly that. The 7-day promise is real – I noticed patterns I never knew existed. Highly recommend to all women!'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-violet-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Women Are Saying
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join thousands of women who have transformed their understanding of their bodies with the Cycle Clarity Starter Kit
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Image */}
              <div className="flex-shrink-0">
                <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden ring-4 ring-violet-100">
                  <img
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                {/* Stars */}
                <div className="flex justify-center md:justify-start gap-1 mb-4">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>

                {/* Quote */}
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  "{testimonials[currentIndex].text}"
                </p>

                {/* Author */}
                <div>
                  <h4 className="text-xl font-semibold text-gray-900">
                    {testimonials[currentIndex].name}
                  </h4>
                  <p className="text-violet-600 font-medium">
                    {testimonials[currentIndex].role}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 bg-white rounded-full p-3 shadow-lg hover:bg-violet-50 transition-colors cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl text-violet-600"></i>
          </button>
          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 bg-white rounded-full p-3 shadow-lg hover:bg-violet-50 transition-colors cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl text-violet-600"></i>
          </button>

          {/* Dots Navigation */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  index === currentIndex
                    ? 'bg-violet-600 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Ready to Start Your Journey?
          </h3>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Join these amazing women and discover the power of understanding your body's natural rhythms
          </p>
          <a
            href="https://payhip.com/b/EvcbM"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-violet-600 text-white px-12 py-4 rounded-full text-lg font-semibold hover:bg-violet-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Your Starter Kit Today
          </a>
        </div>
      </div>
    </section>
  );
}
